const englishSpeakingMarkets: Array<string> = [
  'al',
  'ao-en',
  'ao-pt',
  'ag',
  'am',
  'au',
  'az-az',
  'az-en',
  'bh-en',
  'bd-bn',
  'bd-en',
  'bb',
  'by-en',
  'bz-en',
  'bj-en',
  'bt',
  'ba',
  'bw',
  'br-en',
  'bn-en',
  'bn-ms',
  'bg-bg',
  'bg-en',
  'bf-en',
  'bi-en',
  'cv-en',
  'kh',
  'cm-en',
  'ca-en',
  'td-en',
  'co-en',
  'km-en',
  'ci-en',
  'hr-en',
  'hr-hr',
  'cw-en',
  'cy',
  'cz',
  'cd-sw',
  'dk-en',
  'dj-en',
  'dm',
  'eg-en',
  'gq-en',
  'ee-en',
  'ee-et',
  'sz',
  'et-am',
  'et-en',
  'fj',
  'ga-en',
  'ge',
  'gh',
  'gd',
  'gn-en',
  'gw-en',
  'gy',
  'ht-en',
  'hk-en',
  'is-en',
  'is-is',
  'in-en',
  'in-hi',
  'id-en',
  'iq-en',
  'ie',
  'il-en',
  'jm',
  'jo-en',
  'kz-en',
  'ke-en',
  'ke-sw',
  'ki',
  'xk-en',
  'xk-sr',
  'kw-en',
  'kg-en',
  'la',
  'lv-en',
  'lv-lv',
  'lb-en',
  'ls',
  'lr',
  'ly-en',
  'lt-en',
  'lt-lt',
  'mo-en',
  'mg-en',
  'mw',
  'my-en',
  'my-ms',
  'mv-en',
  'ml-en',
  'mt',
  'mh',
  'mr-en',
  'mu',
  'fm',
  'md-en',
  'mn',
  'me-en',
  'me-sr',
  'mz-en',
  'na-af',
  'na-en',
  'nr',
  'np-en',
  'np-ne',
  'nz',
  'ne-en',
  'ng',
  'mk',
  'no-en',
  'om-en',
  'pk-en',
  'pk-ur',
  'pw',
  'ps-en',
  'pg',
  'ph-en',
  'ph-tl',
  'pt-en',
  'qa-en',
  'cg-en',
  'ro-en',
  'ro-ro',
  'rw',
  'ws',
  'sm-en',
  'st-en',
  'sa-en',
  'sn-en',
  'rs-en',
  'rs-sr',
  'sc-en',
  'sl',
  'sg-en',
  'sk-en',
  'sk-sk',
  'si-en',
  'si-sl',
  'sb',
  'za-en',
  'za-zu',
  'kr-en',
  'lk-en',
  'lk-ta',
  'kn',
  'lc',
  'vc',
  'sr-en',
  'tj-en',
  'tz-en',
  'tz-sw',
  'th-en',
  'bs',
  'gm',
  'tl-en',
  'tg-en',
  'to',
  'tt',
  'tr-en',
  'tv',
  'ug-en',
  'ug-sw',
  'ua-en',
  'ae-en',
  'uk',
  'us',
  'uz',
  'vu-en',
  've-en',
  'vn-en',
  'zm',
  'zw',
];

export default englishSpeakingMarkets;
